import { DataGranularityKey } from 'types';

import { DAY_KEY, START_DATE_KEY, YEAR_KEY } from '../../models/data-key';
import { formatValue } from '../filters-helpers';
import isPlayFunctionEnabled from './is-time-slider-play-enabled';

const MAX_LABEL_WIDTH_MAP = {
    [DAY_KEY]: 140,
    [START_DATE_KEY]: 140,
    [YEAR_KEY]: 50,
};

const getTimelineConfig = (
    timeUnitKey: DataGranularityKey | null,
    currentValue: number | string,
    options: number[] | string[],
    theme: any,
    width: number,
    localizer: Function,
    configOverrides?: any,
    permanentlyEnablePlayFunction?: boolean
) => {
    if (!timeUnitKey || options.length < 2) {
        return { show: false };
    }

    const {
        textStyle,
        map: {
            sliderAxisColor,
            sliderPointColor,
            sliderPlayButtonColor,
            sliderPlayButtonBorderColor,
            sliderPlayButtonHoverColor,
            sliderPlayButtonBorderHoverColor,
        },
    } = theme;

    const maxPossibleTicksAmount = Math.round(width / MAX_LABEL_WIDTH_MAP[timeUnitKey]);
    let step = Math.round(options.length / maxPossibleTicksAmount);
    if (maxPossibleTicksAmount >= options.length) {
        step = 1;
    } else if (timeUnitKey === YEAR_KEY) {
        step = Math.ceil((step + 2.5) / 5) * 5;
    }

    const formatter = (v, i) =>
        (i % step === 0 ? formatValue(timeUnitKey, options[i], localizer) || '' : '').toString();

    return {
        ...theme.timeline,
        show: true,
        data: options.map((v, i) => i),
        labels: options.map(formatter),
        currentIndex: currentValue != null ? options.findIndex((v) => v === currentValue) : 0,
        label: {
            position: 'top',
            formatter,
        },
        left: '0',
        right: '0',
        playInterval: 1000,
        tooltip: {
            show: false,
        },
        padding: [60, 50, 5, 50],
        lineStyle: {
            color: sliderAxisColor,
            width: 6,
            borderRadius: 0,
        },
        symbol: 'circle',
        symbolSize: 6,
        itemStyle: {
            color: sliderAxisColor,
        },
        checkpointStyle: {
            symbol: 'image://svg/global-map-checkpoint.svg',
            symbolSize: 32,
        },
        controlStyle: {
            showPlayBtn: permanentlyEnablePlayFunction || isPlayFunctionEnabled(options),
            showPrevBtn: false,
            showNextBtn: false,
            color: sliderPlayButtonColor,
            borderColor: sliderPlayButtonBorderColor,
            itemSize: 32,
        },
        emphasis: {
            controlStyle: {
                color: sliderPlayButtonHoverColor,
                borderColor: sliderPlayButtonBorderHoverColor,
            },
            itemStyle: {
                color: sliderPointColor,
            },
            label: {
                color: textStyle.color,
            },
        },
        ...configOverrides,
    };
};

export default getTimelineConfig;
